"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M3.487 2.153c.807-.806 2.196-.845 3.059-.115l.125.115 2.537 2.538c.667.666.845 1.654.47 2.507l-.078.158-1.492 2.78a8.582 8.582 0 0 0 5.793 5.996l.284.081 2.772-1.492a2.276 2.276 0 0 1 2.538.275l.128.117 2.221 2.222c.424.415.656.977.656 1.582a2.24 2.24 0 0 1-.526 1.447l-.136.148-1.318 1.319c-.42.426-.999.67-1.59.67-.055 0-.11 0-.165-.008A18.871 18.871 0 0 1 1.505 5.236a2.231 2.231 0 0 1 .54-1.63l.123-.133 1.319-1.32Zm1.596.279c-.305 0-.592.1-.824.285l-.11.099-1.326 1.326a1.281 1.281 0 0 0-.385 1.018 17.94 17.94 0 0 0 16.409 16.4c.327.02.657-.086.912-.29l.104-.094 1.326-1.325a1.31 1.31 0 0 0 .385-.934c0-.299-.1-.585-.286-.822l-.1-.113-2.22-2.222a1.325 1.325 0 0 0-1.433-.287l-.13.062-2.939 1.585a.42.42 0 0 1-.343.035 9.468 9.468 0 0 1-6.967-6.972.462.462 0 0 1 .011-.254l.035-.082L8.786 6.91a1.315 1.315 0 0 0-.134-1.456l-.098-.109-2.538-2.53a1.339 1.339 0 0 0-.933-.383Zm16.95-.933c.051 0 .091.006.128.017l.055.022a.405.405 0 0 1 .153.1c.044.045.072.09.098.142a.549.549 0 0 1 .03.119l.003.052v5.741a.461.461 0 0 1-.466.467.459.459 0 0 1-.46-.376l-.008-.084V3.093l-7.09 7.084a.439.439 0 0 1-.327.139.445.445 0 0 1-.33-.143.463.463 0 0 1-.056-.586l.06-.072 7.082-7.083H16.3a.462.462 0 0 1-.468-.467.46.46 0 0 1 .383-.459L16.3 1.5h5.734Z",
    clipRule: "evenodd"
  })]
});